var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.54 14.002H9C8.45 14.002 8 13.552 8 13.002V9.46195C8 9.20195 8.11 8.94195 8.29 8.76195L13.61 3.44195C12.7697 3.1544 11.8881 3.00578 11 3.00195C6.8 3.00195 3 6.22195 3 11.202C3 14.382 5.44 18.122 10.33 22.422C10.71 22.752 11.29 22.752 11.67 22.422C16.56 18.122 19 14.372 19 11.202C19 10.192 18.84 9.26195 18.55 8.40195L13.24 13.712C13.06 13.892 12.8 14.002 12.54 14.002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.0024H12.12L18.28 5.84244L16.16 3.72244L10 9.88244V12.0024ZM19.71 3.00244L19 2.29244C18.9075 2.19974 18.7976 2.12619 18.6766 2.07601C18.5557 2.02583 18.426 2 18.295 2C18.164 2 18.0343 2.02583 17.9134 2.07601C17.7924 2.12619 17.6825 2.19974 17.59 2.29244L16.87 3.01244L18.99 5.13244L19.71 4.41244C19.8027 4.31993 19.8763 4.21004 19.9264 4.08907C19.9766 3.9681 20.0024 3.83841 20.0024 3.70744C20.0024 3.57648 19.9766 3.44679 19.9264 3.32582C19.8763 3.20485 19.8027 3.09496 19.71 3.00244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationManagement);
export default __webpack_public_path__ + "static/media/locationManagement.e22a2add4926947fe96773e1c792bc1a.svg";
export { ForwardRef as ReactComponent };